/**
 * Copy for the Payments content tab's table (S-05, PE-1007), behind
 * `erp_app_proof_of_payment_ingestion_v1`. Mounted as `accounts.paymentsList`.
 *
 * The flag labels are the payment record's (`accounts.paymentRecord.flags`), so the list and the
 * record always name a flag alike, and each flag's reason and a blocked payment's reason are the
 * server's sentences, rendered as they arrive. The empty-state bodies for the first run, Blocked and
 * Confirmed are DL-146's corrected copy; the Cancelled lines and the copy-the-set strings are the
 * ticket's proposed copy (DL-146). The status pills reuse the Status filter's labels (D-28).
 */
export default {
  readAccess: 'You have read access to payments.',
  columns: {
    vendor: 'Vendor',
    cashAmount: 'Cash amount',
    reference: 'Reference',
    status: 'Status',
    flag: 'Flag',
    age: 'Age',
    createdBy: 'Created by / on',
    action: 'Action',
  },
  ageOrder: {
    oldestFirst: 'oldest first',
  },
  filters: {
    search: 'Search reference, vendor or amount',
    status: {
      label: 'Status',
      AwaitingProof: 'Awaiting proof',
      Confirmed: 'Confirmed',
      Blocked: 'Blocked',
      Cancelled: 'Cancelled',
    },
    vendor: {
      label: 'Vendor',
      search: 'Search vendors',
    },
    age: {
      label: 'Age',
      Oldest: 'Oldest first',
      Newest: 'Newest first',
      PastMatchingWindow: 'Past the 30-day window',
    },
  },
  reference: {
    label: 'Reference',
  },
  age: {
    days: 'Under a day | 1 day | {count} days',
    card: 'Age {age}',
  },
  createdBy: {
    person: '{name} · {date}',
    notRecorded: 'Not recorded · {date}',
  },
  view: {
    label: 'View',
    card: 'View payment',
    name: 'View payment {reference}',
  },
  copySet: {
    label: 'Copy 1 payment | Copy all {count} payments',
    copying: 'Copying payments',
    copied: 'Copied 1 payment. | Copied {count} payments.',
    failed: 'The payments could not be copied. Nothing was copied.',
    tooLarge: 'Up to {max} payments can be copied at once. Filter the list to copy fewer.',
  },
  announcement: {
    loading: 'Loading payments.',
    count: 'No payments listed. | 1 payment listed. | {count} payments listed.',
    error: 'The payments list could not be loaded.',
  },
  states: {
    firstRun: {
      title: 'No payments yet',
      description: 'Payments appear here as soon as one is logged.',
    },
    awaitingProof: {
      title: 'Nothing is awaiting proof',
      description:
        'Every proof received has settled itself, without anyone touching a payment. There is nothing here to do, which is the state this filter exists to reach.',
    },
    blocked: {
      title: 'Nothing is blocked',
      description:
        'No payment is held at the confirm-time check. Payments still waiting for a proof are under Awaiting proof.',
    },
    confirmed: {
      title: 'No payments have confirmed yet',
      description: 'Payments confirm here as their proofs arrive or are attached.',
    },
    cancelled: {
      title: 'No payments have been cancelled',
    },
    noResults: {
      title: 'No payments match this search',
      description: 'The filters are narrower than the list, not broken.',
      withTotal:
        'The filters are narrower than the list, not broken. Clearing them brings the 1 payment back. | The filters are narrower than the list, not broken. Clearing them brings all {count} payments back.',
    },
    showAll: 'Show all payments',
    clearFilters: 'Clear filters',
    error: {
      message: 'The payments list could not be loaded.',
      retry: 'Retry',
    },
  },
};
